// import components
import { styled, ListItem, Box, BoxProps } from '@mui/material';

// import types
import {
  SpanBoxProps,
  StyledAutocompleteListBoxProps
} from './MuiAutocompleteOption.types';

export const StyledAutocompleteListItem = styled(ListItem)(({ theme }) => ({
  '&.has-checkbox': {
    paddingLeft: theme.spacing(2)
  },
  '.left-icon': {
    marginRight: theme.spacing(2)
  }
}));

export const StyledAutocompleteListBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isInvalid'
})<StyledAutocompleteListBoxProps>(({ theme, isInvalid }) => ({
  color: isInvalid ? theme.palette.error.main : undefined
}));

export const StyledSpanBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isHighlighted'
})<BoxProps & SpanBoxProps>(({ theme, isHighlighted }) => ({
  color: isHighlighted ? theme.palette.primary.main : 'inherit'
}));
